import { useQuery } from "@apollo/client";
import { MY_HR_GET_SPOUSES } from "my-hr/graphql";
import { useOcCurrentUserState, useOcPolling } from "oc/hooks";

export const useMyHrSpousesData = () => {
  let { employeeCode } = useOcCurrentUserState();
  const { data, loading, error } = useQuery(MY_HR_GET_SPOUSES, {
    fetchPolicy: "cache-and-network",
    pollInterval: useOcPolling(1000 * 60),
    variables: {
      employeeCode,
    },
  });
  const result = data?.spouses || [];
  return {
    data: result,
    loading,
    error,
  };
};

export default useMyHrSpousesData;
